<div (click)="closeDialog(false)" class="close-button"></div>
<div class="title">{{ 'EXTERNAL_MISSION.title' | translate }}</div>
<div class="subtitle">1. {{ 'EXTERNAL_MISSION.subtitle_1' | translate }}{{ ioName }}</div>
<div class="text">{{ 'EXTERNAL_MISSION.text_1' | translate }}</div>
<div class="d-flex justify-content-center">
  <ns-button
      [style]="isMobile() ? 'width:100%':''"
      (callback$)="openIOWebsite(externalLink)"
      [classes]="'w-100 ns-font-w-700 ns-font-16 ns-mb-40 ns-pr-46'"
      [faIcon]="'fa-solid fa-arrow-up-right-from-square'"
      [iconAlignedToBorder]="true"
      [iconRightSide]="true"
      [text]="'EXTERNAL_MISSION.button_1' | translate"
      [type]="Constants.BUTTON_TYPE_DEFAULT_GREEN_FILLED_N">
  </ns-button>
</div>
<div class="subtitle">2. {{ 'EXTERNAL_MISSION.subtitle_2' | translate }}</div>
<div class="checkbox-container">
  <div class="checkbox">
    <input (click)="checkTrustCheckbox()" formControlName="trustCheckbox" id="trust-checkbox" type="checkbox">
    <i *ngIf="isChecked" class="fa-solid fa-check"></i>
  </div>
  <label [innerHTML]="'EXTERNAL_MISSION.checkbox_text' | translate:{ngo: currentLanguage === 'en' ? ioName : ioNameEn}" for="trust-checkbox"></label>
</div>
<div class="d-flex justify-content-center">
  <ns-button
      [disabled]="!isChecked"
      (callback$)="openConfirmWorkingHoursModal()"
      [style]="isMobile() ? 'width:100%; margin-bottom:20px':''"
      [classes]="'w-100 ns-font-w-800'"
      [text]="'EXTERNAL_MISSION.button_2' | translate"
      [type]="Constants.BUTTON_TYPE_DEFAULT_YELLOW_FILLED_B">
  </ns-button>
</div>
